<template>
  <v-card class="item_card" @click="func(item)">
    <div class="integration-visual">
      <img v-if="item.logo" class="integration-logo" :src="item.logo" :alt="item.displayTitle || title" />
      <Icon v-else :name="item.icon" />
    </div>
    <!-- <div v-if="item.in_dev" class="dev">В разработке</div> -->
    <div class="title">{{ item.displayTitle || title }}</div>
    <div class="text">{{ item.text }}</div>
  </v-card>
</template>
<script>
import Icon from '../SetIcon.vue';
export default {
  components: {
    Icon,
  },
  props: ['item', 'title', 'func'],
};
</script>
<style scoped>
.integration-visual {
  display: flex;
  align-items: center;
  height: 36px;
  margin-bottom: 12px;
}
.integration-logo {
  display: block;
  width: auto;
  height: 24px;
  max-width: 100%;
  object-fit: contain;
  object-position: left;
}
.dev {
  margin-left: auto;
  width: max-content;
  padding: 6px 12px;
  background: #4b5eff;
  color: #eee;
  font-weight: 600;
  border-radius: 8px;
  position: absolute;
  right: 12px;
  top: 12px;
}
.item_card {
  display: flex;
  flex-direction: column;
  padding: 16px;
  text-align: left;
  cursor: pointer;
  width: 100%;
  height: 100%;
  min-width: 0;
  box-sizing: border-box;
}
.icon {
  display: flex;
  align-items: center;
  max-width: 100%;
}
.title {
  margin-bottom: 12px;
  font-style: normal;
  font-weight: 700;
  font-size: 19px;
  line-height: 120%;
  color: #404247;
}
.text {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 140%;
  color: #55575c;
}
</style>
